import { dataTimesCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTimesCircle = /*#__PURE__*/createIcon(dataTimesCircle)
export default IconTimesCircle
